/**
 * Ramène une date saisie à l'année en cours.
 *
 * À la création d'un évènement ou d'une session, une date tapée avec une année
 * passée (13/02/2023) est presque toujours une année oubliée ou recopiée d'un
 * ancien mail : elle devient 13/02 de l'année en cours. Une année future est
 * respectée — planifier en janvier prochain reste possible.
 *
 * `iso` est un 'aaaa-mm-jj' (la valeur d'un <input type="date">). Tout le reste,
 * y compris la saisie en cours, est rendu tel quel.
 *
 * Le champ date de Chrome envoie « 0002-02-13 » dès le premier chiffre de
 * l'année tapée : corriger ces états intermédiaires réécrirait la saisie sous
 * les doigts. Seule une année complète (quatre chiffres, ≥ 1000) est donc
 * corrigée.
 */
export function anneeCourante(iso, maintenant = new Date()) {
  const m = /^(\d{4,6})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
  if (!m) return iso;

  const annee = Number(m[1]);
  const cible = maintenant.getFullYear();
  if (annee < 1000 || annee >= cible) return iso;

  // Le 29 février d'une année bissextile n'existe pas dans l'année en cours.
  const mois = Number(m[2]);
  const dernierJour = new Date(cible, mois, 0).getDate();
  const jour = Math.min(Number(m[3]), dernierJour);
  return `${cible}-${m[2]}-${String(jour).padStart(2, '0')}`;
}

/** Applique `anneeCourante` à chaque champ date listé d'un objet de formulaire. */
export function anneeCouranteDesChamps(valeurs, champs) {
  const sortie = { ...valeurs };
  for (const nom of champs) {
    if (nom in sortie) sortie[nom] = anneeCourante(sortie[nom]);
  }
  return sortie;
}
